






























import BaseFormMixin from '@/mixins/base-form-mixin';
import IndicatorServices from '@/services/indicator';
import ParamsServices from '@/services/params';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class IndDefinition extends mixins(BaseFormMixin) {
  @PropSync('ind') syncIndDefinition!: any;
  @Prop() formData!: any;

  paramSrv = new ParamsServices();
  indSrv = new IndicatorServices();

  options: any = [
    {
      value: '0',
      label: '指标',
      children: []
    },
    {
      value: '1',
      label: '参数',
      children: []
    }
  ];

  async created() {
    await this.getParamList();
    await this.getIndList();
    if (this.formData.id) {
      this.initEdit();
    }
  }

  initEdit() {
    this.indCompose = this.syncIndDefinition ? this.syncIndDefinition : this.indCompose;
    this.indJoin = this.indCompose.indJoin.length > 0 ? this.indCompose.indJoin : this.indJoin;
    let source: string[] = [];
    if (this.indCompose.sourceIndCode) {
      source.push('0');
      source.push(`${this.indCompose.sourceIndCode}/${this.indCompose.sourceIndName}/${this.indCompose.sourceIndSetCode}`);
    } else if (this.indCompose.sourceParamCode) {
      source.push('1');
      source.push(`${this.indCompose.sourceParamCode}/${this.indCompose.sourceParamName}`);
    }
    this.sourceValue = source;
    let indJoinValues: string[][] = [];
    this.indJoin.forEach((v: any, index: number) => {
      let val: string[] = [];
      if (v.indCode) {
        val.push('0');
        val.push(`${v.indCode}/${v.indName}/${v.indSetCode}`);
      } else if (v.paramCode) {
        val.push('1');
        val.push(`${v.paramCode}/${v.paramName}`);
      }
      indJoinValues.push(val);
    });
    this.indJoinValues = indJoinValues;
  }

  refreshParams() {
    this.getParamList();
  }

  async getParamList() {
    let list = await this.paramSrv.getEnableList({ paramCategory_eq: 0 });
    this.options[1].children = list.map((v: any) => ({
      value: `${v.paramCode}/${v.paramName}`,
      label: v.paramName
    }));
  }

  async getIndList() {
    let list = await this.indSrv.getEnableList();
    this.options[0].children = list.map((v: any) => ({
      value: `${v.indCode}/${v.indName}/${v.indSetCode}`,
      label: v.indName
    }));
  }

  sourceValue: string[] = [];
  changeSource(e: string[]) {
    let [type, value] = e;
    if (type === '0') {
      let [indCode, indName, indSetCode] = value.split('/');
      this.indCompose.sourceIndCode = indCode;
      this.indCompose.sourceIndName = indName;
      this.indCompose.sourceIndSetCode = indSetCode;
      this.indCompose.sourceParamCode = '';
      this.indCompose.sourceParamName = '';
    }
    if (type === '1') {
      let [paramCode, paramName] = value.split('/');
      this.indCompose.sourceParamCode = paramCode;
      this.indCompose.sourceParamName = paramName;
      this.indCompose.sourceIndId = '';
      this.indCompose.sourceIndCode = '';
      this.indCompose.sourceIndName = '';
      this.indCompose.sourceIndSetCode = '';
    }
    this.changeSyncDefInfo();
  }

  indJoinValues: string[][] = [];
  changeIndJoin(e: string[], k: number) {
    let [type, value] = e;
    if (type === '0') {
      let [indCode, indName, indSetCode] = value.split('/');
      this.indJoin[k].indCode = indCode;
      this.indJoin[k].indName = indName;
      this.indJoin[k].indSetCode = indSetCode;
      this.indJoin[k].paramId = '';
      this.indJoin[k].paramCode = '';
      this.indJoin[k].paramName = '';
    }
    if (type === '1') {
      let [paramCode, paramName] = value.split('/');
      this.indJoin[k].paramCode = paramCode;
      this.indJoin[k].paramName = paramName;
      this.indJoin[k].indId = '';
      this.indJoin[k].indCode = '';
      this.indJoin[k].indName = '';
      this.indJoin[k].indSetCode = '';
    }
    this.changeSyncDefInfo();
  }

  // 组合指标
  indCompose: any = {
    indJoin: [],
    sourceIndCode: '',
    sourceIndId: 0,
    sourceIndName: '',
    sourceIndSetCode: '',
    sourceIndSetName: '',
    sourceParamCode: '',
    sourceParamId: 0,
    sourceParamName: ''
  };

  indJoin: any[] = [
    {
      indCode: '',
      indId: 0,
      indName: '',
      indSetCode: '',
      indSetName: '',
      joinOperator: '',
      paramCode: '',
      paramId: 0,
      paramName: '',
      paramValue: ''
    }
  ];
  addConf() {
    this.indJoin.push({
      indCode: '',
      indId: 0,
      indName: '',
      indSetCode: '',
      indSetName: '',
      joinOperator: '',
      paramCode: '',
      paramId: 0,
      paramName: '',
      paramValue: ''
    });
  }

  removeConf(k: number) {
    this.indJoin.splice(k, 1);
  }

  @Watch('indCompose')
  onindComposeChange() {
    this.changeSyncDefInfo();
  }

  @Watch('indJoin')
  onIndJoinChange() {
    this.changeSyncDefInfo();
  }

  changeSyncDefInfo() {
    this.syncIndDefinition = this.indCompose;
    this.syncIndDefinition.indJoin = this.indJoin;
  }
}
